export default __webpack_public_path__ + "static/media/why5.e33b6b47.svg";